import { useEffect, useMemo, useState } from 'react'
import { setFilters, setQuery } from '../../../actions/dsl-dive-center-actions'
import { useDispatch, useSelector } from 'react-redux'
import get from 'lodash/get'
import has from 'lodash/has'

import { parseQuery } from '../../../utils'

const filtersMock = {
  other: [
    {
      title: 'fun dives',
      items: [],
      isActive: false,
      othersFilter: 'dive_trip',
    },
    {
      title: 'snorkeling',
      items: [],
      isActive: false,
      othersFilter: 'snorkelling',
    },
    {
      title: 'conservation',
      items: [],
      isActive: false,
      othersFilter: 'conservation_activity',
    },

    {
      title: 'social',
      items: [],
      isActive: false,
      othersFilter: 'social_event',
    },
  ],
}

const getIsIntersect = (Qparams, itemParams) => {
  const nq = Array.isArray(Qparams) ? Qparams : [Qparams]
  return nq.some((value) => itemParams.includes(Number(value)))
}

export default function useActivityFilter(activityType, courseFilters) {
  const queryParams = parseQuery()
  const dispatch = useDispatch()
  const [initQuery, setInitQuery] = useState({})
  const { dslFiltersState } = useSelector((state) => state)

  const patchFilterItems = (
    items,
    queryParams,
    activityType,
    filterTitle,
    queryName,
  ) => {
    const activeId = []
    const pi = items.map((item) => {
      const filterId = has(item, 'course') ? item.course : item.id
      const isActive = getIsIntersect(queryParams[activityType], filterId)
      if(isActive) {
        activeId.push(item.id)
      }
      return {
        ...item,
        isChecked: isActive,
      }
    })
    setInitQuery((prevState) => {
      return {
        ...prevState,
        [queryName]: [...get(prevState, queryName, []), ...activeId.flat()],
        highlight_courses: queryParams['courses'],
      }
    })
    return items.length > 1
      ? [
        {
          title: 'all',
          isChecked: false,
          id: [],
        },
        ...pi,
      ]
      : pi
  }
  const patchFilters = (filters, activityType) => {
    return filters.reduce((acc, filter) => {
      const { items, title, query_name: queryName } = filter
      const patchedItems = patchFilterItems(
        items,
        queryParams,
        activityType,
        title,
        queryName,
      )
      const isFilterActive = patchedItems.some(({ isChecked }) => isChecked)
      return [
        ...acc,
        {
          ...filter,
          items: patchedItems,
          isActive: isFilterActive,
        },
      ]
    }, [])
  }

  const patchedCourseFilters = useMemo(
    () => patchFilters(courseFilters, 'courses'),
    [],
  )

  const filters = {
    courses: patchedCourseFilters,
    other: filtersMock.other,
  }

  useEffect(() => {
    dispatch(setQuery(initQuery))
    dispatch(setFilters(filters))
  }, [])

  return {
    filters: dslFiltersState[activityType],
  }
}
